import { useQuery } from "react-query";
import { getTerms } from "./api";

export const useGetTerms = (params) => {
  return useQuery(["GET_TERMS", params], (k, params) => getTerms(params));
};
